module.exports = __webpack_public_path__ + "static/media/green_turtle.30c00d93.png";